import React from 'react';
import { Loader2 } from 'lucide-react';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary' | 'accent' | 'ghost' | 'outline';
  size?: 'sm' | 'md' | 'lg';
  isLoading?: boolean;
  fullWidth?: boolean;
}
export function Button({
  children,
  variant = 'primary',
  size = 'md',
  isLoading = false,
  fullWidth = false,
  className = '',
  disabled,
  ...props
}: ButtonProps) {
  const baseStyles = 'inline-flex items-center justify-center rounded-lg font-medium transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-offset-2 disabled:opacity-50 disabled:cursor-not-allowed';
  const variants = {
    primary: 'bg-[#1e3a5f] text-white hover:bg-[#162c46] focus:ring-[#1e3a5f]',
    secondary: 'bg-white text-[#1e3a5f] border border-[#1e3a5f] hover:bg-[#faf8f5] focus:ring-[#1e3a5f]',
    accent: 'bg-[#f59e0b] text-white hover:bg-[#d97706] focus:ring-[#f59e0b]',
    ghost: 'bg-transparent text-[#1e3a5f] hover:bg-[#faf8f5] focus:ring-[#1e3a5f]',
    outline: 'bg-transparent text-white border border-white hover:bg-white/10 focus:ring-white'
  };
  const sizes = {
    sm: 'px-3 py-1.5 text-sm',
    md: 'px-4 py-2 text-base',
    lg: 'px-6 py-3 text-lg'
  };
  const widthClass = fullWidth ? 'w-full' : '';
  return <button className={`${baseStyles} ${variants[variant]} ${sizes[size]} ${widthClass} ${className}`} disabled={disabled || isLoading} {...props} data-id="element-214">
      {isLoading && <Loader2 className="mr-2 h-4 w-4 animate-spin" data-id="element-215" />}
      {children}
    </button>;
}